import { filter } from "rxjs/operators";
import { Component } from "@angular/core";
import { ProfileService } from "../profile/providers/profile.service";
import { Observable } from "rxjs";
import { Profile } from "../profile/store/profile.entity";
import { BrandingService } from "../branding/providers/branding.service";
import { BrandingState } from "../branding/store/branding.state";
import { SurvicateService } from "../../providers/survicate/survicate.service";
import { NgClass, AsyncPipe } from "@angular/common";
import { FooterLegalLinksComponent } from "../footer-legal-links/footer-legal-links.component";
import { TranslationComponent } from "../../providers/translate/component/translation.component";
import { TranslatePipe } from "@ngx-translate/core";

@Component({
    selector: "app-footer",
    templateUrl: "./footer.component.html",
    styleUrls: ["./footer.component.scss"],
    imports: [
    NgClass,
    FooterLegalLinksComponent,
    TranslationComponent,
    AsyncPipe,
    TranslatePipe
],
})
export class FooterComponent {
    public brandingData$: Observable<BrandingState>;
    public profileData$: Observable<Profile>;

    constructor(
        private profileService: ProfileService,
        private brandingService: BrandingService,
        private survicateService: SurvicateService,
    ) {
        this.profileData$ = this.profileService
            .getCurrentProfileDataObserver()
            .pipe(filter((e) => e !== null && e !== undefined));
        this.brandingData$ = this.brandingService
            .getBrandingSettingsFromStore()
            .pipe(filter((e) => e !== null && e !== undefined));
    }

    async showFeedbackSurvey(): Promise<void> {
        await this.survicateService.showFeedbackSurvey();
    }
}
